import { useState } from 'react';
import { UsersThree, Table as TableIcon } from '@phosphor-icons/react';
import StaffTab from './salary/StaffTab';
import SheetTab from './salary/SheetTab';

const tabBtn = (active) =>
  `px-5 py-2.5 rounded-md border-2 border-[#0A0A0A] font-bold text-sm flex items-center gap-2 transition-all ${
    active
      ? 'bg-[#A3E635] text-[#0A0A0A] shadow-[3px_3px_0px_0px_rgba(10,10,10,1)]'
      : 'bg-[#0F3622] text-white hover:-translate-y-0.5'
  }`;

const Salary = () => {
  const [tab, setTab] = useState('sheet');

  return (
    <div data-testid="salary-page">
      <div className="mb-6">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-white mb-2" style={{fontFamily: 'Cabinet Grotesk, sans-serif'}}>
          Staff Salary
        </h1>
        <p className="text-base font-medium text-white">
          Add staff once, then just mark attendance each month — salary is calculated automatically (Basic ÷ 30 per day).
        </p>
      </div>

      <div className="flex gap-3 mb-6">
        <button data-testid="salary-tab-sheet" className={tabBtn(tab === 'sheet')} onClick={() => setTab('sheet')}>
          <TableIcon size={18} weight="bold" />
          Salary Sheet
        </button>
        <button data-testid="salary-tab-staff" className={tabBtn(tab === 'staff')} onClick={() => setTab('staff')}>
          <UsersThree size={18} weight="bold" />
          Staff
        </button>
      </div>

      {tab === 'staff' ? <StaffTab /> : <SheetTab />}
    </div>
  );
};

export default Salary;
